(() => {
  'use strict';
  if (customElements.get('rc-guide')) return;
  customElements.define('rc-guide', class extends HTMLElement {
    connectedCallback() {
      this.frame = requestAnimationFrame(() => {
        this.events?.abort();
        this.events = new AbortController();
        const mobile = window.matchMedia('(max-width: 640px)');
        const table = this.querySelector('.rc-guide-table');
        const slider = this.querySelector('.rc-guide-slider');
        const sync = () => {
          for (const [element, hidden] of [[table, mobile.matches], [slider, !mobile.matches]]) {
            element.hidden = hidden;
            element.setAttribute('aria-hidden', String(hidden));
          }
          // Local may have upgraded the slider while its wrapper was hidden.
          slider.RESIZE_WATCHER?.();
          if (mobile.matches && slider.sliderEnabled) slider.resetSlider?.();
        };
        mobile.addEventListener('change', sync, {signal: this.events.signal});
        sync();
      });
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      this.events?.abort();
    }
  });
})();
